<!--
 * @Description: 备忘录
 * @Author: PF
 * @Date: 2023-02-23 17:07:24
 * @LastEditors: PF
 * @LastEditTime: 2024-10-11 11:39:33
-->

<template>
  <div>
    <el-dialog class="wp70 hp80" :model-value="openBeiWangLu" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">备忘录</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openBeiWangLu', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box mb0" :model="dataGrid.parms">
              <el-form-item class="mr10">
                <el-input placeholder="标题" v-model="dataGrid.parms.bt" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item class="mr10">
                <el-select placeholder="类型" v-model="dataGrid.parms.lx" clearable filterable :teleported="false" @change="bindTable()">
                  <el-option v-for="item in lxData" :key="item.value" :label="item.name" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box mb0 ">
              <el-button class="w200" type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
              <el-button class="w200" type="warning" @click="remove()"><span class="iconfont icon-shanchu"></span>批量删除</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main class="hp100">
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column type="selection" width="55" align="center" />
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="创建时间" prop="cjsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="类型" prop="lx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <div v-for="(item, index) in lxData" :key="index">
                    <span v-if="scope.row.lx == item.value">{{item.name}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="开始时间" prop="kssj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="结束时间 " prop="jssj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="180" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                  <el-button link type="primary" @click="openEdit=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
        </el-container>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="shuaXin" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="shuaXin" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import {
  closeWindow,
  loadList,
  submitDataGridAction,
  loadSelect
} from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from '@/pages/bangong/qita/beiwanglu/add.vue'
import edit from '@/pages/bangong/qita/beiwanglu/edit.vue'
import detail from '@/pages/bangong/qita/beiwanglu/detail.vue'

const props = defineProps({
  openBeiWangLu: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openBeiWangLu', 'ReturnData'])

const lxData = ref()

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'cjsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/bangong/beiwanglu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
const shuaXin = () => {
  emits('ReturnData')
  bindTable()
}
watch(
  () => props.openBeiWangLu,
  () => {
    if (props.openBeiWangLu) {
      bindTable()
      loadSelect({
        url: '/api/v2/bangong/beiwanglu/beiwangluleixing',
        data: lxData
      })
    }
  },
  { deep: true, immediate: true }
)
// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/bangong/beiwanglu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}
</script>
